import httpGet from "./httpget";
import httpPost from "./httppost";
import httpPut from "./httpPut";
import httpDelete from "./httpdelete";
const domain = "https://webpdfapi.foxitcloud.cn";


// 获取用户信息
// export const createShare = (config = {}) => {
//   return httpGet({
//     url: `${domain}/v1/api/doc/docCoordinationShare/createShare`,
//     params:config.params,
//     config
//   });
// };
// 创建云办公账号协同分享
export const createShare = (config = {}) => {
  return httpPost({
    url: `${domain}/v1/api/doc/docCoordinationShare/createShare`,
    params:config.params,
    config
  });
};
// 取消云办公账号协同分享
export const cancelShare = (config = {}) => {
  return httpPost({
    url: `${domain}/v1/api/doc/docCoordinationShare/cancelShare`,
    params:config.params,
    config
  });
};

// 重置云办公账号协同分享链接
export const resetShareUrl = (config = {}) => {
  return httpPost({
    url: `${domain}/v1/api/doc/docCoordinationShare/resetShareUrl`,
    params:config.params,
    config
  });
};

// 修改云办公账号协同分享信息
export const updateShare = (config = {}) => {
  return httpPut({
    url: `${domain}/v1/api/doc/docCoordinationShare/updateShare`,
    params:config.params,
    config
  });
};
// 查询协作者列表
export const docCoordinationShareUserList = (config = {}) => {
  return httpGet({
    url: `${domain}/v1/api/doc/docCoordinationShare/docCoordinationShareUserList`,
    params:config.params,
    config
  });
};
// 添加协作者
export const addCollaborator = (config = {}) => {
  return httpPost({
    url: `${domain}/v1/api/doc/docCoordinationShare/addCollaborator`,
    params:config.params,
    config
  });
};
// 批量添加协作者
export const batchAddCollaborator = (config = {}) => {
  return httpPost({
    url: `${domain}/v1/api/doc/docCoordinationShare/batchAddCollaborator`,
    params:config.params,
    // config
  });
};
// 修改协作者权限
export const updateCollaborator = (config = {}) => {
  return httpPut({
    url: `${domain}/v1/api/doc/docCoordinationShare/updateCollaborator`,
    params:config.params,
    config
  });
};
// 批量修改协作者权限
export const batchUpdateCollaborator = (config = {}) => {
  return httpPut({
    url: `${domain}/v1/api/doc/docCoordinationShare/batchUpdateCollaborator/${config.shareId}`,
    params:config.params,
    config
  });
};
// 移除协作者
export const removeCollaborator = (config = {}) => {
  return httpDelete({
    url: `${domain}/v1/api/doc/docCoordinationShare/removeCollaborator`,
    params:config.params,
    config
  });
};

// 获取企业部门集合
export const externalDepartments = (config = {}) => {
  return httpGet({
    url: `${domain}/v1/api/external/departments`,
    params:config.params,
    config
  });
};
// 获取企业用户集合
export const externalUsers = (config = {}) => {
  return httpGet({
    url: `${domain}/v1/api/external/users`,
    params:config.params,
    config
  });
};
// 打开分享连接
export const openShare = (config = {}) => {
  return httpGet({
    url: `${domain}/v1/api/doc/docCoordinationShare/openShare`,
    params:config.params,
    config
  });
};
// 校验密码
export const checkSharePwd = (config = {}) => {
  return httpGet({
    url: `${domain}/v1/api/doc/docCoordinationShare/checkSharePwd`,
    params:config.params,
    config
  });
};
// 获取文件分享信息
export const getDocShare = (config = {}) => {
  return httpGet({
    url: `${domain}/v1/api/doc/docCoordinationShare/getDocShare`,
    params:config.params,
    config
  });
};
